import { render, staticRenderFns } from "./WizardStepFrame.vue?vue&type=template&id=12d3e7d9&scoped=true"
import script from "./WizardStepFrame.vue?vue&type=script&lang=js"
export * from "./WizardStepFrame.vue?vue&type=script&lang=js"
import style0 from "./WizardStepFrame.vue?vue&type=style&index=0&id=12d3e7d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3e7d9",
  null
  
)

export default component.exports